import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Upload,
} from "antd";
import { useNavigate } from "react-router";
import CommonOtp from "../../components/otp";
import TransferService from "../../services/transfer.service";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import { NumericFormat } from "react-number-format";
import {
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyNumbers,
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  amountFormat,
} from "../../services/common.service";
import Dragger from "antd/es/upload/Dragger";
import dayjs from "dayjs";
import successIcon from "../../assests/images/success.png";
import {
  accountListSelector,
  modeSelector,
  selectedAccountSelector,
} from "../../store/selectors/app.selector";
import AccountDisplay from "../../components/account-display";
import downloadIcon from "../../assests/images/template-download.png";
import AccountService from "../../services/accounts.service";
import { setErrorMessage } from "../../store/actions/error.action";
import { AiOutlineLeft } from "react-icons/ai";
import { CONFIG } from "../../environment";
import moment from "moment";
import { ReactComponent as TitleIcon } from "../../assests/images/bulkpaybreadupload.svg";
import AccountCard from "../../components/account-card";
import AccountSelectedCard from "../../components/account-selected-card";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import AccountDisplayView from "../../components/account-display-view";
import ExcelUpload from "../../components/excel-upload";
import { MdOutlineDelete, MdOutlineModeEdit } from "react-icons/md";

function BulkUpload() {
  const dispatch = useDispatch();
  const [stage, setStage] = useState(1);
  const accountList = useSelector(accountListSelector);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [formDetails, setFormDetails] = useState({});
  const [verifyDetails, setVerifyDetails] = useState({});
  const [message, setMessage] = useState("");
  const [uploadFile, setUploadFile] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  const [fileProcessList, setFileProcessList] = useState([]);
  const [fileTypeName, setFileTypeName] = useState([]);
  const [fileProcessName, setFileProcessName] = useState([]);
  const [fileProcessId, setFileProcessId] = useState(0);
  const [selectedFileName, setSelectedFileName] = useState("");
  const selectedAccount = useSelector(selectedAccountSelector);
  const mode = useSelector(modeSelector);
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [cancelVisible, setCancelVisible] = useState(false);
  const [uploadFileVisible, setUploadFileVisible] = useState(false);
  const { t } = useTranslation();
  const [excelFileName, setExcelFileName] = useState([]);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    getFileProcessList();
  }, []);

  const getFileProcessList = useCallback(async () => {
    try {
      const response = await TransferService.getFileProcessList();
      if (response.status === 200) {
        const uniqueFileProcessList = response.data.reduce((acc, current) => {
          const existingItem = acc.find(
            (item) => item.processName === current.processName
          );
          if (!existingItem) {
            acc.push(current);
          }
          return acc;
        }, []);
        setFileTypeName(uniqueFileProcessList);
        setFileProcessName(
          response.data.filter((e) => e.processName === "Bulk Payment")
        );
        setFileProcessList(response.data);
      }
    } catch (err) {}
  }, []);

  // const onChangeProcessName = useCallback(
  //   (value) => {
  //     const filteredProcesses = fileProcessList.filter(
  //       (e) => e.processName === value
  //     );
  //     setFileProcessName(filteredProcesses);
  //   },
  //   [fileProcessList]
  // );

  const onChangeProcessId = useCallback(
    (value) => {
      const fileProcessIdCopy = fileProcessList?.filter((e) =>
        e.fileProcessId === value ? e : ""
      )[0];
      setFileProcessId(fileProcessIdCopy.fileProcessId);
    },
    [fileProcessList, fileProcessId]
  );

  const onChange = useCallback((info) => {
    setMessage("");
    if (info.file.status === "done") {
      console.log(info?.file?.originFileObj?.name);
      setSelectedFileName(info?.file?.originFileObj?.name);
      setUploadFile(info?.file?.originFileObj);
      setExcelFileName(info.file.originFileObj);
      setDisabled(true);
    }
  });

  const onRemove = useCallback(() => {
    setUploadFile("");
    setSelectedFileName("");
    setDisabled(false);
  });

  const handleAction = useCallback(({ file, onSuccess }) => {
    console.log(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  });

  const onDownload = useCallback(async () => {
    try {
      const reqParams = {
        fileProcessId: fileProcessId,
      };
      if (fileProcessId === 0) {
        dispatch(
          setErrorMessage({
            data: {
              message: t("upload.please_select_process_name", {
                defaultValue: "Please Select Process Name",
              }),
            },
          })
        );
        return;
      } else {
        await AccountService.downloadTemplateForBulk(reqParams);
      }
    } catch (err) {}
  }, [fileProcessId]);

  const onVerify = useCallback(
    async (value) => {
      try {
        if (selectedFileName.length === 0) {
          setMessage(
            t("upload.upload_file_required", {
              defaultValue: "Upload file should be required",
            })
          );
          return;
        }
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );
        setFormDetails(value);
        let formData = new FormData();
        formData.append("module", "BULKUPLOAD");
        formData.append("srcAccNo", srcAccDetails.accountNo);
        formData.append("srcAccCcy", srcAccDetails.accountCurrency);
        formData.append("srcAccBrn", srcAccDetails.branchId);
        formData.append("file", uploadFile);
        formData.append("fileProcessId", fileProcessId);
        formData.append(
          "valueDate",
          dayjs(value?.valueDate).format("DD-MM-YYYY")
        );
        formData.append("remarks", value.remarks);
        formData.append("mode", mode);
        const response = await TransferService.fileUploadInitVerify(formData);
        if (response.status === 200) {
          setVerifyDetails(response.data["data"]);
          setLoader(false);
          setStage(2);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [uploadFile, fileProcessId, selectedAccount]
  );

  const onConfirm = useCallback(
    async (value) => {
      try {
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );
        let formData = new FormData();
        formData.append("module", "BULKUPLOAD");
        formData.append("srcAccNo", srcAccDetails.accountNo);
        formData.append("srcAccCcy", srcAccDetails.accountCurrency);
        formData.append("srcAccBrn", srcAccDetails.branchId);
        formData.append("file", uploadFile);
        formData.append("fileProcessId", fileProcessId);
        formData.append("valueDate", value?.valueDate);
        formData.append("totalAmount", value?.totalAmount);
        formData.append("totalRecCount", value?.totalRecCount);
        formData.append("remarks", value.remarks);
        formData.append("mode", mode);
        formData.append("otp", value?.otp);
        formData.append("enabledTOTP", value?.enabledTOTP);
        const response = await TransferService.fileUploadInitConfirm(formData);
        if (response.status === 200) {
          setMessage(response.data.message);
          setLoader(false);
          setSuccessVisible(true);
        }
        setLoader(false);
      } catch (error) {
        setOtp("");
      }
    },
    [selectedAccount, uploadFile, fileProcessId]
  );

  const handleResendOtp = useCallback(
    async (value) => {
      try {
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );
        let formData = new FormData();
        formData.append("module", "BULKUPLOAD");
        formData.append("srcAccNo", srcAccDetails.accountNo);
        formData.append("srcAccCcy", srcAccDetails.accountCurrency);
        formData.append("srcAccBrn", srcAccDetails.branchId);
        formData.append("file", uploadFile);
        formData.append("fileProcessId", fileProcessId);
        formData.append("valueDate", value?.valueDate);
        formData.append("remarks", value.remarks);
        formData.append("mode", mode);
        const response = await TransferService.fileUploadInitVerify(formData);
        if (response.status === 200) {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [uploadFile, fileProcessId, selectedAccount]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) =>
              onConfirm({ ...formDetails, ...verifyDetails, ...values })
            }
            handleResendOtp={() =>
              handleResendOtp({ ...formDetails, ...verifyDetails })
            }
            cancelTransaction={() => {
              navigate("/dashboard");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row">
          <div className="d-flex align-items-center">
            {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <AccountDisplay type="image"  currencyFilter={false}/>
            </div> */}
          </div>
        </div>
        <div>
          <Form onFinish={onVerify} layout="vertical" form={form}>
            <div className="row">
              {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                name={"processName"}
                label="File Type"
                rules={[{ required: true, message: "File Type is required" }]}
              >
                <Select
                  onChange={(value) => {
                    onChangeProcessName(value);
                    form.setFieldsValue({
                      fileProcessId: undefined,
                    });
                  }}
                  placeholder="File Type"
                  bordered={true}
                  size="large"
                >
                  {fileTypeName.map((option, idx) => (
                    <Select.Option value={option.processName} key={idx}>
                      {option.processName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div> */}

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name={"fileProcessId"}
                  label={t("pages.upload.process_name", {
                    defaultValue: "Process Name",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("upload.process_name_req", {
                        defaultValue: "Process Name is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    onChange={(value) => onChangeProcessId(value)}
                    placeholder={t("pages.upload.process_name", {
                      defaultValue: "Process Name",
                    })}
                    bordered={true}
                    size="large"
                  >
                    {fileProcessName.map((option, idx) => (
                      <Select.Option value={option.fileProcessId} key={idx}>
                        {option.templateName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.common_my_accounts.value_date", {
                    defaultValue: "Value Date",
                  })}
                  name={"valueDate"}
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "pages.my_accounts.common_my_accounts.value_date_req",
                        {
                          defaultValue: "Value Date is required",
                        }
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    // inputReadOnly={true}
                    allowClear={false}
                    showToday={false}
                    disabledDate={(current) =>
                      current.isBefore(moment().subtract(1, "days"))
                    }
                    placeholder={t(
                      "pages.my_accounts.common_my_accounts.value_date",
                      {
                        defaultValue: "Value Date",
                      }
                    )}
                    // format={"DD/MM/YYYY"}
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    size="large"
                  />
                </Form.Item>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="remarks"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.remark_require", {
                        defaultValue: "Reason is required",
                      }),
                    },
                  ]}
                  label={t("common.remarks", { defaultValue: "Reason" })}
                >
                  <Input
                    placeholder={t("common.remarks", {
                      defaultValue: "Reason",
                    })}
                    size="large"
                    onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                    maxLength={30}
                  />
                </Form.Item>
              </div>
              <div className="col-12">
                {disabled === false ? (
                  <Dragger
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    height={100}
                    multiple={false}
                    listType={"picture"}
                    onChange={onChange}
                    onRemove={onRemove}
                    customRequest={handleAction}
                    maxCount={1}
                  >
                    <p className="ant-upload-text" style={{ fontSize: 12 }}>
                      {t("common.click_drag_to_upload", {
                        defaultValue:
                          "Click or drag file to this area to upload",
                      })}
                    </p>
                  </Dragger>
                ) : (
                  <div className="d-flex justify-content-between">
                    <div>{uploadFile?.name}</div>
                    <div>
                      <Upload
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={onChange}
                        customRequest={handleAction}
                        maxCount={1}
                        showUploadList={false}
                      >
                        <MdOutlineModeEdit size={"20"} className="Pending" />
                      </Upload>
                      <MdOutlineDelete
                        size={"20"}
                        onClick={onRemove}
                        className="delete"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="col-12">
                <p className="text-danger">{message}</p>
              </div>
            </div>
            <div className="d-flex justify-content-end  mt-3">
              <Button
                onClick={() => navigate("/dashboard")}
                type="default"
                className="secondary-btn"
                style={{ marginRight: 20 }}
                size="large"
              >
                {t("buttons.cancel_btn", {
                  defaultValue: "Cancel",
                })}
              </Button>
              <Button
                type="primary"
                className="primary-btn"
                htmlType="submit"
                size="large"
              >
                {t("buttons.next_btn", {
                  defaultValue: "Next",
                })}
              </Button>
            </div>
          </Form>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <div>
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>
        {/* <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
              <AccountDisplayView />
            </div>
          </div>
        </div> */}

        <div className="mt-3 confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.upload.process_name", {
                  defaultValue: "Process Name",
                })}
              </label>
              <span>
                {
                  fileProcessList.find(
                    (ele) => ele?.fileProcessId === fileProcessId
                  ).templateName
                }
              </span>
            </div>
            <div
              className="confirm-label-wrapper pay-now-text"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setUploadFileVisible(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <label>
                {t("pages.upload.view_uploaded_file", {
                  defaultValue: "View Uploaded File",
                })}
              </label>
              <span style={{ textDecoration: "underline" }}>
                {uploadFile?.name}
              </span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.my_accounts.common_my_accounts.value_date", {
                  defaultValue: "Value Date",
                })}
              </label>
              <span>{verifyDetails?.valueDate}</span>
            </div>
            {/* <div className="confirm-label-wrapper">
              <label> {t("pages.landing.total_amount", {
                        defaultValue: "Total Amount",
                      })}</label>
              <span>
                {amountFormat(
                  verifyDetails?.totalAmount,
                  verifyDetails?.srcAccCcy
                )}
              </span>
            </div> */}
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.upload.transaction_count", {
                  defaultValue: "Transaction Count",
                })}
              </label>
              <span>{verifyDetails?.totalRecCount}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>{t("common.remarks", { defaultValue: "Reason" })}</label>
              <span>{formDetails?.remarks}</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-5">
          <Button
            onClick={() => setStage(1)}
            type="default"
            style={{ marginRight: 30 }}
            className="secondary-btn"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            onClick={() => {
              verifyDetails?.["otpEnabled"]
                ? setStage(3)
                : onConfirm({
                    ...formDetails,
                    ...verifyDetails,
                    ...{ otp: CONFIG.DEFAULT_OTP },
                  });
            }}
            type="primary"
            className="primary-btn"
            size="large"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
        {/* <Breadcrumb separator=">"> */}
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/transfer")}>
              {" "}
              {t("navigation.transfer", {
                defaultValue: "Transfers",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.bulk_upload", {
                defaultValue: "Bulk Payment Upload",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.bulk_upload", {
                defaultValue: "Bulk Payment Upload",
              })}
            </h3>
          </div>
          {stage === 1 && (
            <div className="btn-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-end style-xs">
              <Button onClick={() => onDownload()} className="btn-primary">
                <img src={downloadIcon} alt="" height={23} width={20} />
                <span className="font-weight-600 mx-1">
                  {t("buttons.template_btn", {
                    defaultValue: "Template",
                  })}
                </span>
              </Button>
              <Button
                type="primary hide-xs"
                onClick={() => navigate("/bulk-payment-upload/history")}
              >
                {t("pages.sendMoney.common_sendMoney.bulk_upload_history", {
                  defaultValue: "Bulk Payment Upload History",
                })}
              </Button>

              <Button
                type="primary hide-lg"
                onClick={() => navigate("/bulk-payment-upload/history")}
              >
                {t("pages.sendMoney.common_sendMoney.bulk_upload_history", {
                  defaultValue: "Bulk Upload History",
                })}
              </Button>
            </div>
          )}
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card"  >
              <AccountCard />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card"  >
              <AccountSelectedCard />
            </Card>
          </div>
        )}

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className=" deposit-render-section application-card ">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={""}
        open={uploadFileVisible}
        footer={null}
        width={800}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        <div align="center">
          <ExcelUpload excelFile={excelFileName} />
          <Button
            type="primary"
            className="primary-btn mt-2"
            onClick={() => {
              setUploadFileVisible(false);
            }}
            size="large"
          >
            {t("buttons.okay_btn", {
              defaultValue: "Okay",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/dashboard");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title={t("pages.otp.quit", {
          defaultValue: "Quit ?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.otp.quitTitle", {
            defaultValue:
              "If you quit now, you will have to start all over again. Are you sure you want to quit?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            type="default"
            className="secondary-btn"
            onClick={() => setCancelVisible(false)}
            size="large"
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/dashboard");
            }}
            size="large"
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default BulkUpload;
